const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.superadmin_boq_template_groups/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.superadmin_boq_template_groups/LIST_BOQ_TEMPLATE_GROUPS_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
